import { useMemo } from 'react';
import type { AppState } from '../../shared/api';
import { countryCode } from '../../shared/countries';
import { CanImage } from '../components/CanImage';
import { shortMeta, sizeLabel } from '../format';

interface Props {
  state: AppState;
  onOpen: (entryId: number) => void;
}

export function Wall({ state, onOpen }: Props) {
  const canById = useMemo(() => new Map(state.cans.map((c) => [c.id, c])), [state.cans]);

  // Only the categories you have cans from; the database has 20+.
  const sections = state.categories
    .map((cat) => ({ cat, tiles: state.entries.filter((e) => canById.get(e.canId)?.categoryId === cat.id) }))
    .filter((s) => s.tiles.length > 0);

  return (
    <main className="screen">
      <header className="wall-head">
        <div className="wall-head__row">
          <h1 className="title">
            MONSTERS
          </h1>
          <div className="wall-head__stats">
            <div className="wall-stat">
              <b>{state.entries.length}</b>
              <br />
              {state.entries.length === 1 ? 'blik' : 'blikken'}
            </div>
            <div className="wall-stat">
              <b>{state.wanted.length}</b>
              <br />
              wanted
            </div>
          </div>
        </div>
      </header>

      {sections.map(({ cat, tiles }) => (
        <section key={cat.id} className="cat" aria-labelledby={`cat-${cat.id}`}>
          <div className="cat-head">
            <h2 className="cat-head__name" id={`cat-${cat.id}`}>
              {cat.name}
            </h2>
            <div className="cat-head__bar" />
            <div className="cat-head__stat">{tiles.length}</div>
          </div>
          <div className="schap">
            {tiles.map((e) => {
              const can = canById.get(e.canId);
              const name = can?.name ?? '';
              return (
                <button
                  key={e.id}
                  type="button"
                  className="tile-btn"
                  onClick={() => onOpen(e.id)}
                  aria-label={`${name}, ${countryCode(e.country)}, ${sizeLabel(e.sizeMl)}`}
                >
                  <div className="schap__img">
                    <CanImage imageId={can?.imageId} />
                  </div>
                  <div className="schap__ledge" />
                  <div className="schap__text">
                    <div className="schap__name">{name}</div>
                    <div className="schap__meta">{shortMeta(e.country, e.sizeMl)}</div>
                  </div>
                </button>
              );
            })}
          </div>
        </section>
      ))}
      {sections.length === 0 && (
        <div className="cat-empty" style={{ padding: '24px 20px' }}>
          Je collectie is nog leeg. Voeg je eerste blik toe met de + in het menu.
        </div>
      )}
    </main>
  );
}
